<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-warning-outline"></i> 预警记录</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="物资名称">
          <el-input
            v-model="queryParams.key_word"
            placeholder="请输入物资名称"
            clearable
            style="width: 260px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="exportExcel">导出</el-button>
        </el-row>
      </el-form>

      <!-- 固定物资表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="assetsCatName" label="物资类别" />
        <el-table-column prop="consumableAssetsName" label="物资名称" />
        <el-table-column prop="assetsUnit" label="单位" />
        <el-table-column prop="alarmNum" label="预警值" />
        <el-table-column prop="restQuantity" label="剩余数量" />
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationBar from "@/components/PaginationBar";
import { downloadFile, parseDateRange } from "@/utils/util";

import {
  getConsumableAssetsAlarmList,
  getExcelConsumableAssetsAlarmList,
} from "@/api/material";

export default {
  name: "WarningRecord",
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        key_word: "",
        useDateRange: [],
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery(page) {
      this.currentPage = page || 1;
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.useDateRange
      );

      getConsumableAssetsAlarmList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.key_word,
        begin_date,
        end_date,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        key_word: "",
        useDateRange: [],
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleTabChange() {
      this.resetQuery();
    },
    exportExcel() {
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.useDateRange
      );
      getExcelConsumableAssetsAlarmList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.key_word,
        begin_date,
        end_date,
      }).then((res) => {
        downloadFile(
          res.data,
          "低值易耗预警记录.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
